export default "__VITE_ASSET__ClS1YvKv__"